import { render, staticRenderFns } from "./CtaComp.vue?vue&type=template&id=7c2e00e6"
import script from "./CtaComp.vue?vue&type=script&lang=js"
export * from "./CtaComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports